import { Component } from "react";

import { Button } from "@/components/ui/button";

/**
 * 2026-07-13 P0 FIX: Admin dashboard'da arka planda periyodik çağrılan bir
 * endpoint (örn. release-gate/sanity-last) 500/504 gibi bir HTML hata sayfası
 * döndürdüğünde veya herhangi bir alt widget render sırasında beklenmeyen bir
 * hata fırlattığında, React'in varsayılan davranışı TÜM uygulamayı
 * unmount edip "Uncaught runtime error" beyaz ekranına düşürmekti (uygulamada
 * hiçbir ErrorBoundary yoktu). Bu bileşen, sardığı alanı izole eder: içindeki
 * bir widget/sayfa çökse bile navbar/sidebar ve uygulamanın geri kalanı
 * çalışmaya devam eder, sadece o alan "veri alınamadı" durumuna düşer.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div
            className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-red-300 bg-red-50 p-8 text-center text-sm text-red-700"
            data-testid="error-boundary-fallback"
          >
            <p>Bu bölüm yüklenirken bir hata oluştu. Veri geçici olarak alınamıyor.</p>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={this.handleRetry}
              data-testid="error-boundary-retry-button"
            >
              Tekrar Dene
            </Button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
